import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { DistributorContractArea } from '../../models/distributor-contract-area';
import { DistributorContractAreasService } from '../services/distributor-contract-areas.service';

@Injectable()
export class DistributorContractAreaResolver implements Resolve<DistributorContractArea>
{
	private areasService: DistributorContractAreasService;

	constructor(areasService: DistributorContractAreasService)
	{
		this.areasService = areasService;
	}

	resolve(route: ActivatedRouteSnapshot): Promise<DistributorContractArea>
	{
		return this.areasService.getDistributorContractArea(+route.params['areaId']);
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/resolvers/distributor-contract-area.resolver.ts